class CarouselProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.template-404__slide-container');
    if (swiperContainer) {
      new Swiper(swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            scrollbar: {
              el: this.querySelector('.swiper-scrollbar'),
              draggable: true,
              dragSize: 348,
            },
          },
        },
      });
    } else {
      console.error('Swiper container not found.');
    }
  }
}

customElements.define('carousel-product', CarouselProducts);